import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Box from "../../lib/ui/ui-box"
import { Colors } from "../../lib/theme"
import Text from "../text"

const SegmentedInput = styled.input`
  overflow: hidden;
  position: absolute;

  padding: 0;
  margin: -1px;
  border: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
`

const Label = styled(Text)`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  position: relative;
`

const Wrapper = styled(Box)`
  position: relative;
  display: flex;
  flex: 1;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 7px;
  margin-top: 5px;
  border: 1px solid #dce0e0;
  background-color: ${props =>
    props.checked ? Colors.actionPrimary : "white"};
  &:first-child ${Label} {
    border-top-left-radius: 3;
    border-bottom-left-radius: 3;
  }

  &:last-child ${Label} {
    border-top-right-radius: 3;
    border-bottom-right-radius: 3;
  }
`

export default class SegmentedControlRadio extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.number.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    isFirstItem: PropTypes.bool,
    isLastItem: PropTypes.bool
  }

  render() {
    const { name, label, value, checked, onChange } = this.props

    return (
      <Wrapper checked={checked}>
        <SegmentedInput
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={e => onChange(e.target.value)}
        />
        <Label
          fontWeight="700"
          checked={checked}
          color={checked ? "white" : "text"}
        >
          {label}
        </Label>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/segmented-control/segmented-control-radio.component.js